// Types
import type { TPaginationButtonProps, TPaginationProps } from './Pagination.type';

export const PAGINATION_DEFAULT_PROPS: TPaginationProps = {
	activePage: 1,
	totalPage: 1,
	onClick: () => {
	},
};

export const PAGINATION_BUTTON_DEFAULT_PROPS: TPaginationButtonProps = {
	label: '1',
};
